import breakpoints from '@config/breakpoints.json'

export type Breakpoint = keyof typeof breakpoints

// Same queries as the @custom-media --<breakpoint>-up / --<breakpoint>-down that postcss.config.mjs defines.
export function up(breakpoint: Breakpoint) {
  return `(width >= ${breakpoints[breakpoint]}px)`
}

export function down(breakpoint: Breakpoint) {
  return `(width < ${breakpoints[breakpoint]}px)`
}
